import {HyperDropComponent} from "./HyperDropComponent";

export class HyperDropTooltip extends HyperDropComponent {

  isVisible: boolean = false;
  position: string = 'top';
  message: string = '';


  onMount(options): void {
    // Set position from data attribute if available
    if (options.position) {
      this.position = options.position;
    }
    if (options.message) {
      this.message = options.message;
    }

    this.elements.trigger.addEventListener('mouseenter', () => this.show());
    this.elements.trigger.addEventListener('mouseleave', () => this.hide());
    this.elements.trigger.addEventListener('focus', () => this.show());
    this.elements.trigger.addEventListener('blur', () => this.hide());


    if (!this.elements.tooltip && this.message) {
      this.elements.tooltip = document.createElement('div');
      this.elements.tooltip.className = `custom-tooltip tooltip-${this.position}`;
      this.elements.tooltip.textContent = this.message;
      this.elements.trigger.appendChild(this.elements.tooltip);
    }

    this.elements.arrow = document.createElement('div');
    this.elements.arrow.className = 'tooltip-arrow';
    this.elements.tooltip.appendChild(this.elements.arrow);
    //console.log(this.elements)
  }

  show() {
    this.elements.tooltip.classList.add('visible');
    //console.log('Tooltip shown');
  }

  hide() {
    this.elements.tooltip.classList.remove('visible');
  }


}
